import React from 'react';
import Link from 'gatsby-link';
import { Helmet } from 'react-helmet';

import HelmetSEO from '../components/seo';
import Components from '../components/components';
import LinkBack from '../components/link-back';
import { stripNode, GetSubmenu } from '../helpers/get-contents';

const SectionPage = ({ data }) => {
    if (!data) {
        return <div>section page missing data</div>;
    }
    const page = data.page.edges[0].node;
    const sectionPages = data.sectionPages.edges;
    const locations = stripNode(data.locations.edges);
    const regions = stripNode(data.regions.edges);
    const certificates = stripNode(data.certificates.edges);
    //const footer = data.footer.edges[0].node.frontmatter;
    let seo = {
        title: '',
        description: '',
        image: '',
    };
    page.modules.forEach(module => {
        if (module.__typename == 'DatoCmsText') {
            seo.title = module.title;
            seo.description = module.body;
        }
        if (module.__typename == 'DatoCmsMiniHero') {
            seo.image = module.image.sizes.src;
        }
    });

    return (
        <div>
            <HelmetSEO {...seo} />
            <Components
                content={{
                    __typename: 'submenu',
                    items: GetSubmenu(page.parentPage.slug, sectionPages),
                    backlink: page.parentPage,
                }}
            />
            <LinkBack parent={page.parentPage} />
            <div className="section indented-contents gray-dividers">
                <div className="mt-60" />
                {page.modules.map((module, i) => (
                    <Components
                        key={i}
                        content={module}
                        locations={locations}
                        regions={regions}
                        certificates={certificates}
                    />
                ))}
            </div>
            <Components
                content={{
                    __typename: 'DatoCmsGiantLinkContainer',
                    links: page.links,
                }}
            />
        </div>
    );
};

export default SectionPage;

export const SectionPageQuery = graphql`
    query SectionLasdfndinesdfrssdfsdsdffddsfsdfsdfsdffssddsfsdffsdfdfertrtegPageQsdfsduery1sfsdf1(
        $slug: String!
    ) {
        page: allDatoCmsSectionPage(filter: { slug: { eq: $slug } }) {
            edges {
                node {
                    pageName
                    slug
                    parentPage {
                        slug
                        pageName
                    }
                    modules {
                        __typename
                        ... on DatoCmsText {
                            title
                            body
                        }
                        ... on DatoCmsTraderCollection {
                            traders {
                                ... on DatoCmsTrader {
                                    ...TraderFragment
                                }
                            }
                        }
                        ... on DatoCmsTraderProfile {
                            trader {
                                id
                                ...TraderFragment
                            }
                        }
                        ... on DatoCmsVideo {
                            video {
                                ...VideoFragment
                            }
                        }
                        ... on DatoCmsImage {
                            image {
                                sizes(
                                    maxWidth: 1100
                                    imgixParams: { fm: "jpg", auto: "compress" }
                                ) {
                                    base64
                                    aspectRatio
                                    src
                                    srcSet
                                    sizes
                                }
                            }
                            caption
                        }
                        ... on DatoCmsFactBar {
                            facts {
                                title
                                body
                            }
                        }
                        ... on DatoCmsMiniHero {
                            title
                            body
                            image {
                                ...HeroImageFragment
                            }
                        }
                        ... on DatoCmsTestimonialModule {
                            testimonial {
                                quote
                                customer
                                company
                            }
                        }
                    }
                    links {
                        ...GiantLinkFragment
                    }
                }
            }
        }
        sectionPages: allDatoCmsSectionPage {
            edges {
                node {
                    pageName
                    position
                    parentPage {
                        slug
                    }
                    slug
                }
            }
        }
        locations: allDatoCmsLocation(
            sort: { fields: [position], order: ASC }
        ) {
            edges {
                node {
                    ...LocationFragment
                }
            }
        }
        regions: allDatoCmsRegion(sort: { fields: [position], order: ASC }) {
            edges {
                node {
                    region
                    position
                }
            }
        }
        certificates: allDatoCmsCertificate {
            edges {
                node {
                    title
                    body
                    document {
                        url
                    }
                }
            }
        }
    }
`;

// date(formatString: "MMMM DD, YYYY")



// WEBPACK FOOTER //
// ./src/templates/section-template.js